import React, {useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Button} from "../../../../../components/Button";
import {ChevronsDown1} from "../../../../../icons/ChevronsDown1";
import {ChevronsDown2} from "../../../../../icons/ChevronsDown2";
import {Icons1} from "../../../../../icons/Icons1";
import {Icons19} from "../../../../../icons/Icons19";
import {NameMenuDarkTrue} from "../../../../../icons/NameMenuDarkTrue";
import {TrailingIcon14} from "../../../../../icons/TrailingIcon14";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import {FrameCorp} from "../../../../../components/FrameCorp";
import "./style.css";

export const CorporativoLandingTelco = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();
  const scrollRef = useRef(null);

  // const handleButtonClick = () => {
  //   const currentParams = location.search;
  //   navigate(`/corporativo-card-details${currentParams}`);
  // };

  return (
      <div className="contenedor">
        <div className="corporativo-landing-telco" ref={scrollRef}>
          {/* {isFocused && <div className="overlay" onClick={toggleFocus}></div>} */}
          <div className="div-3">
            <div className="overlap-3">
              <header className="header">
                <div className="overlap-group-7">
                  <div className="rectangle-4" />

                  <div className="frame-6">
                    <FrameCorp color="#FFFFFF" />
                  </div>

                  <div className="frame-7">
                    <div className="text-wrapper-11">Good morning, Mary</div>

                    <div className="frame-8">
                      <Icons1 className="icon-instance-node-2" color="white" />
                      <NameMenuDarkTrue
                          className="icon-instance-node-2"
                          color="white"
                      />
                    </div>
                  </div>
                </div>
              </header>

              <img className="vector-2" alt="Vector" src="/img/vector-101.svg" />

              <div className="frame-9">
                <div className="accounts">
                  <div className="tarjtetas">
                    <div className="title">Accounts</div>

                    <div className="frame-10">
                      <Icons19 className="icon-instance-node-2" color="white" />
                      <div className="menu-copy">
                        <div className="oval" />

                        <div className="oval-2" />

                        <div className="oval-3" />
                      </div>
                    </div>
                  </div>

                  <div
                      className="account"
                      // onClick={handleButtonClick}
                      style={{ background: "#FFFFFF" }}
                  >
                    <div>

                      <div
                          className="text-wrapper-12"
                          style={{ fontSize: 16, marginTop: 20, marginBottom: 20 }}
                      >
                        <strong>My linked account</strong>
                      </div>

                      <p className="element-USD">
                        <span className="span">$13,000</span>

                        <span className="text-wrapper-13">.23</span>

                        <span className="text-wrapper-14">&nbsp;</span>

                        <span className="text-wrapper-15">USD</span>
                      </p>
                    </div>

                    <div className="frame-12">
                      <p className="main-account">
                      <span className="text-wrapper-16">
                        **** **** **** 2357
                      </span>
                      </p>

                      <Button
                          className="button-instance"
                          divClassName="button-4"
                          leadingIcon={false}
                          size="small"
                          text="Transactions"
                          trailingIcon
                          trailingIcon14StyleOverrideClassName="button-5"
                          trailingIcon14Color={colors.secundario}
                          type="text"
                      />
                    </div>
                  </div>
                </div>
                {/*
              <div className="botonera">
                <div className="frame-13">
                  <img
                    className="invoice"
                    alt="Invoice"
                    src="/img/invoice.svg"
                  />

                  <div className="texto-iconos">Pay Bills</div>
                </div>

                <div className="frame-14">
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group-8">
                      <div className="ellipse-3" />

                      <img className="star" alt="Star" src="/img/star-1.svg" />

                      <img
                        className="vector-3"
                        alt="Vector"
                        src="/img/vector-2.svg"
                      />
                    </div>
                  </div>

                  <div className="texto-iconos">Goals</div>
                </div>

                <div className="frame-13">
                  <img
                    className="btn-icon-contacts"
                    alt="Btn icon contacts"
                    src="/img/btn-icon-contacts-2.svg"
                  />

                  <div className="texto-iconos">Contacts</div>
                </div>

                <div className="frame-15">
                  <img className="plus" alt="Plus" src="/img/plus.svg" />

                  <div className="texto-iconos">Hub</div>
                </div>
              </div> */}

                <div className="cards">
                  <div className="div-4">
                    <div className="title-2">Plans</div>

                    <div className="frame-16">
                      <div className="menu-copy">
                        <div className="oval-4" />

                        <div className="oval-5" />

                        <div className="oval-6" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="balances">
                  <div className="div-5">
                    <svg
                        width={101}
                        height={101}
                        style={{ marginTop: 60, marginLeft: 30 }}
                        viewBox="0 0 101 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                          cx={50.7441}
                          cy={50.5261}
                          r={44}
                          stroke="#f0f0f0"
                          strokeWidth={12}
                      />
                      <mask id="path-2-inside-1_2608_2064" fill="white">
                        <path d="M94.747 50.5261C98.0591 50.5261 100.781 53.2206 100.385 56.509C99.6835 62.3287 97.9621 67.9958 95.2845 73.2453C91.6957 80.2809 86.4914 86.3662 80.0977 91.0029C73.704 95.6396 66.3029 98.6957 58.5005 99.9208C50.6982 101.146 42.7165 100.505 35.2094 98.0516C27.7023 95.5978 20.8833 91.4004 15.3109 85.8034C9.73854 80.2064 5.57132 73.3689 3.1506 65.8511C0.729873 58.3332 0.124514 50.3489 1.38411 42.552C2.32393 36.7344 4.28207 31.1448 7.15341 26.0343C8.77582 23.1467 12.5639 22.5802 15.2366 24.5365C17.9093 26.4927 18.4414 30.2299 16.9295 33.1769C15.1161 36.7111 13.8624 40.519 13.2249 44.4649C12.2675 50.3914 12.7276 56.4604 14.5677 62.1748C16.4077 67.8892 19.5752 73.0865 23.8109 77.3409C28.0465 81.5952 33.2298 84.7857 38.936 86.6509C44.6422 88.5161 50.7092 89.003 56.6399 88.0717C62.5705 87.1404 68.1963 84.8174 73.0562 81.293C77.9161 77.7686 81.872 73.1431 84.5998 67.7953C86.416 64.2347 87.6534 60.4214 88.2776 56.4985C88.7981 53.2275 91.4348 50.5261 94.747 50.5261Z" />
                      </mask>
                      <path
                          d="M94.747 50.5261C98.0591 50.5261 100.781 53.2206 100.385 56.509C99.6835 62.3287 97.9621 67.9958 95.2845 73.2453C91.6957 80.2809 86.4914 86.3662 80.0977 91.0029C73.704 95.6396 66.3029 98.6957 58.5005 99.9208C50.6982 101.146 42.7165 100.505 35.2094 98.0516C27.7023 95.5978 20.8833 91.4004 15.3109 85.8034C9.73854 80.2064 5.57132 73.3689 3.1506 65.8511C0.729873 58.3332 0.124514 50.3489 1.38411 42.552C2.32393 36.7344 4.28207 31.1448 7.15341 26.0343C8.77582 23.1467 12.5639 22.5802 15.2366 24.5365C17.9093 26.4927 18.4414 30.2299 16.9295 33.1769C15.1161 36.7111 13.8624 40.519 13.2249 44.4649C12.2675 50.3914 12.7276 56.4604 14.5677 62.1748C16.4077 67.8892 19.5752 73.0865 23.8109 77.3409C28.0465 81.5952 33.2298 84.7857 38.936 86.6509C44.6422 88.5161 50.7092 89.003 56.6399 88.0717C62.5705 87.1404 68.1963 84.8174 73.0562 81.293C77.9161 77.7686 81.872 73.1431 84.5998 67.7953C86.416 64.2347 87.6534 60.4214 88.2776 56.4985C88.7981 53.2275 91.4348 50.5261 94.747 50.5261Z"
                          stroke={colors.septimo}
                          strokeWidth={22}
                          mask="url(#path-2-inside-1_2608_2064)"
                      />
                      <path
                          d="M35.8777 58.7648C39.764 58.7648 42.4061 56.2335 42.3976 52.7051C42.4061 49.3642 40.0708 46.9608 36.926 46.9608C35.3919 46.9608 34.0708 47.6 33.4572 48.4608H33.3549L33.8066 44.0886H41.4345V41.0716H30.764L29.9373 50.2761L33.2186 50.8642C33.7555 50.1398 34.7953 49.6881 35.8265 49.6881C37.5822 49.6966 38.8436 50.9665 38.8436 52.7989C38.8436 54.6142 37.6078 55.867 35.8777 55.867C34.4118 55.867 33.2271 54.9466 33.1419 53.5915H29.5623C29.6305 56.6085 32.264 58.7648 35.8777 58.7648ZM51.2868 40.8329C47.3833 40.8159 44.7498 43.3727 44.7669 46.8841C44.7754 50.1398 47.0339 52.5006 50.1277 52.5006C52.0453 52.5006 53.7498 51.5716 54.5254 50.0375H54.6447C54.6362 53.4977 53.4345 55.6028 51.1589 55.6028C49.8208 55.6028 48.8578 54.8699 48.5765 53.6H44.9373C45.2782 56.5403 47.6646 58.7648 51.1589 58.7648C55.4799 58.7648 58.2669 55.2704 58.2583 49.3471C58.2498 43.0233 54.8748 40.85 51.2868 40.8329ZM51.3123 43.7307C53.0083 43.7307 54.2612 45.1114 54.2782 46.7733C54.2868 48.4437 52.9657 49.8244 51.2782 49.8244C49.5737 49.8244 48.3549 48.4949 48.3464 46.7818C48.3294 45.0773 49.5993 43.7307 51.3123 43.7307Z"
                          fill="#333"
                      />
                      <path
                          d="M68.0382 53.617C68.0431 54.7655 68.764 55.7349 70.1113 55.7349C71.4437 55.7349 72.1745 54.7655 72.1745 53.617V53.0801C72.1745 51.9267 71.4636 50.9622 70.1113 50.9622C68.7839 50.9622 68.0431 51.9317 68.0382 53.0801V53.617ZM62.9174 47.7903C62.9174 48.9388 63.6433 49.9082 64.9906 49.9082C66.318 49.9082 67.0538 48.9437 67.0488 47.7903V47.2534C67.0538 46.1 66.3379 45.1355 64.9906 45.1355C63.6681 45.1355 62.9174 46.1 62.9174 47.2534V47.7903ZM63.335 55.5261H64.5233L71.5233 45.3443H70.335L63.335 55.5261ZM69.1966 53.0801C69.2015 52.5084 69.4501 51.9565 70.1113 51.9565C70.7974 51.9565 71.0112 52.5084 71.0112 53.0801V53.617C71.0112 54.1888 70.7775 54.7406 70.1113 54.7406C69.4352 54.7406 69.2015 54.1838 69.1966 53.617V53.0801ZM64.0808 47.2534C64.0808 46.6866 64.3294 46.1298 64.9906 46.1298C65.6767 46.1298 65.8904 46.6817 65.8904 47.2534V47.7903C65.8904 48.3621 65.6568 48.9139 64.9906 48.9139C64.3145 48.9139 64.0808 48.3621 64.0808 47.7903V47.2534Z"
                          fill="#333"
                      />
                    </svg>

                    <div className="frame-18">
                      <div className="frame-19">
                        <div className="ellipse-4" />

                        <p className="div-6">
                        <span className="span">
                          81% <br /> consumed
                        </span>
                        </p>
                      </div>

                      <div className="frame-19">
                        <div className="ellipse-5" />

                        <p className="div-6">
                        <span className="span">
                          2GB <br /> available
                        </span>
                        </p>
                      </div>
                    </div>

                    <div className="frame-20">
                      <div className="text-wrapper-23">11 GB plan</div>

                      <TrailingIcon14
                          className="trailing-icon"
                          style={{ color: colors.primario }}
                      />
                    </div>
                  </div>

                  <div className="div-5">
                    <div className="frame-21">
                      <div className="frame-22">
                        <div className="text-wrapper-23">GB Internet</div>

                        <TrailingIcon14
                            className="trailing-icon"
                            style={{ color: colors.primario }}
                        />
                      </div>

                      <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "90%",
                            borderRadius: "10px",

                            fontFamily: "Arial, sans-serif",
                          }}
                      >
                        <div style={{ fontSize: "24px", marginBottom: "8px" }}>
                          $
                        </div>
                        <div style={{ fontSize: "14px", color: "#555" }}>
                          Total Internet balance
                        </div>
                        <div
                            style={{
                              fontSize: "16px",
                              marginTop: "10px",
                              color: "#333",
                              marginBottom: "20px",
                            }}
                        >
                          6.51GB
                        </div>
                        <div style={{ fontSize: "20px", marginBottom: "8px" }}>
                          🕒
                        </div>
                        <div
                            style={{
                              fontSize: "13px",
                              color: "#555",
                              textAlign: "center",
                            }}
                        >
                          Missing until the deadline:
                        </div>
                        <div
                            style={{
                              fontSize: "14px",
                              color: "#888",
                              marginTop: "5px",
                            }}
                        >
                          7 Days
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="banners">
                  <img
                      className="image-4"
                      alt="Image"
                      width="200px"
                      style={{ borderRadius: 12 }}
                      src="/img/promo-telco.png"
                  />
                </div>
              </div>
            </div>

            <div className="menu">
              <div className="single-tab">
                <div className="icon-and-text">
                  <ChevronsDown1 className="icon-instance-node-2" />
                  <div className="text-footer-botones">Send</div>
                </div>
              </div>

              <div className="single-tab">
                <div className="icon-and-text-2">
                  <ChevronsDown2 className="icon-instance-node-2" />
                  <div className="text-footer-botones">Receive</div>
                </div>
              </div>

              <div className="single-tab">
                <div className="icon-and-text-3">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={25}
                      height={25}
                      viewBox="0 0 42.000000 40.000000"
                      preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                        transform="translate(0.000000,40.000000) scale(0.100000,-0.100000)"
                        fill={colors.primario}
                        stroke={colors.primario}
                    >
                      <path d="M10 330 c0 -37 4 -50 13 -47 7 2 12 21 12 47 0 26 -5 45 -12 48 -9 2 -13 -11 -13 -48z" />
                      <path d="M82 298 l3 -83 53 -3 c42 -2 52 0 52 12 0 12 -11 16 -40 16 -33 0 -40 3 -40 19 0 16 8 20 38 23 37 3 37 3 40 51 l3 47 -56 0 -56 0 3 -82z m78 32 c0 -15 -7 -20 -25 -20 -18 0 -25 5 -25 20 0 15 7 20 25 20 18 0 25 -5 25 -20z" />
                      <path d="M232 298 l3 -83 88 -3 87 -3 0 86 0 85 -90 0 -91 0 3 -82z m148 -3 l0 -55 -60 0 -60 0 0 55 0 55 60 0 60 0 0 -55z" />
                      <path d="M310 294 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z" />
                      <path d="M10 225 c0 -9 5 -15 11 -13 14 5 14 21 0 26 -6 2 -11 -4 -11 -13z" />
                      <path d="M10 85 l0 -85 90 0 91 0 -3 83 -3 82 -87 3 -88 3 0 -86z m148 -2 l3 -53 -60 0 -61 0 0 55 0 56 58 -3 57 -3 3 -52z" />
                      <path d="M87 93 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z" />
                      <path d="M230 121 l0 -51 90 0 90 0 0 51 c0 57 -23 66 -28 11 -2 -24 -8 -32 -22 -32 -14 0 -20 9 -22 33 -3 31 -4 32 -55 35 l-53 3 0 -50z m80 -1 c0 -15 -7 -20 -25 -20 -18 0 -25 5 -25 20 0 15 7 20 25 20 18 0 25 -5 25 -20z" />
                      <path d="M230 15 c0 -12 13 -15 55 -15 42 0 55 3 55 15 0 12 -13 15 -55 15 -42 0 -55 -3 -55 -15z" />
                      <path d="M387 24 c-8 -8 1 -24 14 -24 5 0 9 7 9 15 0 15 -12 20 -23 9z" />
                    </g>
                  </svg>
                  <div className="text-footer-botones">QR</div>
                </div>
              </div>

              <div className="single-tab">
                <div className="icon-and-text-4">
                  <svg
                      width={25}
                      height={25}
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.25 4C7.563 4 3.75 7.813 3.75 12.5C3.75 17.187 7.563 21 12.25 21C16.937 21 20.75 17.187 20.75 12.5C20.75 7.813 16.937 4 12.25 4ZM12.25 22.5C6.736 22.5 2.25 18.014 2.25 12.5C2.25 6.986 6.736 2.5 12.25 2.5C17.764 2.5 22.25 6.986 22.25 12.5C22.25 18.014 17.764 22.5 12.25 22.5Z"
                        fill={colors.primario}
                    />
                    <path
                        d="M12.25 3.5C7.28686 3.5 3.25 7.53686 3.25 12.5H4.25C4.25 8.08914 7.83914 4.5 12.25 4.5V3.5ZM3.25 12.5C3.25 17.4631 7.28686 21.5 12.25 21.5V20.5C7.83914 20.5 4.25 16.9109 4.25 12.5H3.25ZM12.25 21.5C17.2131 21.5 21.25 17.4631 21.25 12.5H20.25C20.25 16.9109 16.6609 20.5 12.25 20.5V21.5ZM21.25 12.5C21.25 7.53686 17.2131 3.5 12.25 3.5V4.5C16.6609 4.5 20.25 8.08914 20.25 12.5H21.25ZM12.25 22C7.01214 22 2.75 17.7379 2.75 12.5H1.75C1.75 18.2901 6.45986 23 12.25 23V22ZM2.75 12.5C2.75 7.26214 7.01214 3 12.25 3V2C6.45986 2 1.75 6.70986 1.75 12.5H2.75ZM12.25 3C17.4879 3 21.75 7.26214 21.75 12.5H22.75C22.75 6.70986 18.0401 2 12.25 2V3ZM21.75 12.5C21.75 17.7379 17.4879 22 12.25 22V23C18.0401 23 22.75 18.2901 22.75 12.5H21.75Z"
                        fill={colors.primario}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.6811 16.1925C15.5501 16.1925 15.4181 16.1585 15.2971 16.0875L11.5271 13.8385C11.3011 13.7025 11.1611 13.4575 11.1611 13.1935V8.34546C11.1611 7.93146 11.4971 7.59546 11.9111 7.59546C12.3261 7.59546 12.6611 7.93146 12.6611 8.34546V12.7675L16.0661 14.7975C16.4211 15.0105 16.5381 15.4705 16.3261 15.8265C16.1851 16.0615 15.9361 16.1925 15.6811 16.1925Z"
                        fill={colors.primario}
                    />
                    <path
                        d="M15.6811 16.1925C15.5501 16.1925 15.4181 16.1585 15.2971 16.0875L11.5271 13.8385C11.3011 13.7025 11.1611 13.4575 11.1611 13.1935V8.34546C11.1611 7.93146 11.4971 7.59546 11.9111 7.59546C12.3261 7.59546 12.6611 7.93146 12.6611 8.34546V12.7675L16.0661 14.7975C16.4211 15.0105 16.5381 15.4705 16.3261 15.8265C16.1851 16.0615 15.9361 16.1925 15.6811 16.1925"
                        stroke={colors.primario}
                    />
                  </svg>
                  <div className="text-footer-botones">Transactions</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
